import Swal from 'sweetalert2';
import {
    getCoefficentC3,
    getEffectivePowerUsedByThePropeller,
    getHorizontalDistanceBetweenPropellerAxisAndTheSlopeToe,
    getMinimumWaterDepth,
    getPropellerDistanceFromQuayL,
    getSlopeParameter,
    getVerticalDistanceBetweenTheAxisOfThePropellerAndTheKell,
} from '../../calculation';
import i18n from '../../localization';
import { route } from '../../route/Index';
import { IProject, IProjectInfo } from '../../shared/iProject';
import { redux } from '../../store';
import { setProject } from '../../store/project/projectSlice';
import ProjectProvider from './projectProvider';

const calculationInitialValue = (project: IProject) => {
    project.geometry!.minimumWaterDepth = getMinimumWaterDepth(project.geometry!.designWaterLevel, project.geometry!.designDredgingLevel);
    project.material!.physicalData[0].slopeParameter = getSlopeParameter(project.geometry!.quaySlope);
    project.scenarios = project.scenarios!.map((scenario, i) => ({
        ...scenario,
        effectivePowerUsedByThePropeller: getEffectivePowerUsedByThePropeller(project.engines![i].maximumPowerOfThePropeller, project.engines![i].percentageOfUseInPortManeuvers),
        coefficentC3: getCoefficentC3(scenario.propellerEquippedWithNozzles),
        verticalDistanceBetweenTheAxisOfThePropellerAndTheKell:
            scenario.verticalDistanceBetweenTheAxisOfThePropellerAndTheKell ??
            getVerticalDistanceBetweenTheAxisOfThePropellerAndTheKell(project.engines![i].propellerDiameter, project.engines![i].typeOfPropeller, project.project?.unitOfMeasure!),
        propellerDistanceFromQuayL:
            scenario.propellerDistanceFromQuayL ??
            getPropellerDistanceFromQuayL(
                project.engines![i].propellerDirectionWithRespectToTheQuay,
                project.geometry!.typeOfQuay,
                project.engines![i].typeOfPropeller,
                scenario.vesselBeamBs,
                project.project?.unitOfMeasure!,
            ),
        horizontalDistanceBetweenPropellerAxisAndTheSlopeToe:
            scenario.horizontalDistanceBetweenPropellerAxisAndTheSlopeToe ??
            getHorizontalDistanceBetweenPropellerAxisAndTheSlopeToe(
                project.engines![i].propellerDirectionWithRespectToTheQuay,
                project.geometry!.typeOfQuay,
                project.engines![i].typeOfPropeller,
                scenario.vesselBeamBs,
                project.project?.unitOfMeasure!,
            ),
    }));
    return project;
};

export const getProjectPreviewAsync = ProjectProvider.getProjectPreviewAsync;

export const createProjectAsync = async (payload: IProjectInfo) => {
    let res = await ProjectProvider.createProjectAsync(payload);
    res.data = calculationInitialValue(res.data);
    return res;
};

export const getProjectAsync = async (id: number, email: string) => {
    let res = await ProjectProvider.getProjectAsync(id, email);
    res.data = calculationInitialValue(res.data);
    return res;
};

export const deleteProjectAsync = ProjectProvider.deleteProjectAsync;

const updateProjectAsync = async (payload: IProject) => {
    let res = await ProjectProvider.updateProjectAsync(payload);
    res.data = calculationInitialValue(res.data);
    if (res.status === 200) {
        redux.dispatch(setProject(res.data!));
        Swal.fire({
            title: i18n.t('savedProject'),
            icon: 'success',
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 2000,
        });
    }
    return res;
};

const createFromExistingProjectAsync = ProjectProvider.createFromExistingProjectAsync;

export const saveProjectAsync = async (project: IProject, userEmail: string) => {
    if (project.project?.authorEmail === userEmail) {
        return await updateProjectAsync(project);
    } else {
        let res = await createFromExistingProjectAsync({ project, authorEmail: userEmail });
        window.location.href = window.location.origin + route.design.replace(':projectId', res.data.project!.id!.toString()) + '?withCalculation=true';
    }
};
